import { Api } from "../../api/Api";
import { BooleanThunk } from "../IStore";
import { thunkCreateErrorNotification } from "./NotificationActions";

export const FIND_FILTER_VALUES = "FIND_FILTER_VALUES";

export const thunkFindFilterValues =
  (filterNumber: string): BooleanThunk =>
  async (dispatch) => {
    try {
      const filterValues = await Api.findFilterValues(filterNumber);
      dispatch({
        type: FIND_FILTER_VALUES,
        payload: filterValues,
        filterNumber,
      });
      return true;
    } catch (e) {
      dispatch(thunkCreateErrorNotification("Failed to load filter values with ID " + filterNumber, e));
      return false;
    }
  };
